import { render, staticRenderFns } from "./EventsIndexIndex.vue?vue&type=template&id=b7213a5a&"
import script from "./EventsIndexIndex.vue?vue&type=script&lang=js&"
export * from "./EventsIndexIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports